import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/background-shape-2.svg")